import ExpertProfileAboutComponent from './expert-profile-about.component'

const ExpertProfileAboutModule = angular.module('cdbl.expert-profile-about', [

])
  .component('cdblExpertProfileAbout', ExpertProfileAboutComponent)
  .name

export default ExpertProfileAboutModule
